import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { withTranslation } from "react-i18next";
import { SalonApi } from "apis/SalonApi";

const SalonSelect = ({ value, onChange, isMulti = true, t }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const loadOptions = async (searchValue) => {
        setLoading(true);
        try {
            const response = await SalonApi.getAllSalons({
                page: 1,
                limit: 10,
                search: searchValue
            });
            
            if (response.data.status) {
                const formattedOptions = response.data.data.salons.map(shop => ({
                    value: shop.id,
                    label: shop.name
                }));
                setOptions(formattedOptions);
            }
        } catch (error) {
            console.error('Error loading salons:', error);
        }
        setLoading(false);
    };

    useEffect(() => {
        loadOptions(searchTerm);
    }, [searchTerm]);

    const handleInputChange = (newValue) => {
        setSearchTerm(newValue);
    };

    return (
        <Select
            isMulti={isMulti}
            value={value}
            onChange={onChange}
            options={options}
            isLoading={loading}
            onInputChange={handleInputChange}
            placeholder={t("Select Salons")}
            noOptionsMessage={() => t("No salons found")}
            loadingMessage={() => t("Loading...")}
            className="react-select"
            classNamePrefix="react-select"
        />
    );
};

SalonSelect.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    onChange: PropTypes.func.isRequired,
    isMulti: PropTypes.bool,
    t: PropTypes.func.isRequired
};

export default withTranslation()(SalonSelect); 